import { render, staticRenderFns } from "./about-company.vue?vue&type=template&id=612db6e4&scoped=true&"
import script from "./about-company.vue?vue&type=script&lang=js&"
export * from "./about-company.vue?vue&type=script&lang=js&"
import style0 from "./about-company.vue?vue&type=style&index=0&id=612db6e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612db6e4",
  null
  
)

export default component.exports